export default __webpack_public_path__ + "static/media/calls.f2869b71.wav";